import React from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import PjaxWrapper from '../utils/PjaxWrapper';
import CamShows from '../components/CamShows/CamShows';

function run(elementId) {
	const camShowsElement = document.getElementById(elementId);
	if (camShowsElement) {
		render(
			<CamShows isMobile={false}/>,
			camShowsElement
		);

		PjaxWrapper.addUnloadFunc(() => {
			unmountComponentAtNode(camShowsElement);
		});
	}
}

export {run};
